/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

define({
  OKTA: {
    APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
    WINDOWS: 'http://www.windowsphone.com/en-us/store/app/okta-verify/9df0e2c4-7301-411f-80e5-62fcf6679666'
  },
  GOOGLE: {
    APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    BLACKBERRY: 'https://support.google.com/accounts/answer/1066447'
  },
  STORE: {
    APPLE: 'App Store',
    ANDROID: 'Google Play Store',
    WINDOWS: 'Windows Store',
    BLACKBERRY: 'Blackberry World Store'
  }
});



/** WEBPACK FOOTER **
 ** ./target/js/util/StoreLinks.js
 **/